import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function RefreshAlertIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 21 21" {...props}>
			<path
				d="M16.6663 9.66658C16.4625 8.2001 15.7822 6.8413 14.7302 5.7995C13.6782 4.75769 12.3128 4.09068 10.8444 3.90121C9.376 3.71174 7.88603 4.01032 6.60401 4.75096C5.32199 5.49159 4.31905 6.6332 3.74967 7.99992M3.33301 4.66658V7.99992H6.66634M3.33301 11.3333C3.53681 12.7997 4.21712 14.1585 5.26914 15.2003C6.32117 16.2421 7.68654 16.9092 9.15495 17.0986C10.6234 17.2881 12.1133 16.9895 13.3953 16.2489C14.6774 15.5082 15.6803 14.3666 16.2497 12.9999M16.6663 16.3333V12.9999H13.333M9.99967 7.99992V10.4999M9.99967 12.9999H10.008"
				stroke="#5300C9"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default RefreshAlertIcon;
